<template>
  <div>
    <v-toolbar>
      <v-slide-group>
        <v-slide-item class="mx-2">
          <v-select label="Année" v-model="selected_year" :items="active_years"></v-select>
        </v-slide-item>
        <v-slide-item class="mx-2">
          <SiteTreeSelector nomargin v-model="selected_site_tree"/>
        </v-slide-item>
        <v-slide-item>
          <v-btn color="primary" @click="printStats">Imprimer</v-btn>
        </v-slide-item>
      </v-slide-group>
    </v-toolbar>
    <v-card id="stat-interventions">
      <v-row>
        <v-col>
          <apexchart type="bar" height="350" :options="count_interventions_by_state_graph.chartOptions"
                     :series="count_interventions_by_state_graph.series"></apexchart>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <apexchart type="bar" height="350" :options="realise_mensuel_intervention_graph.chartOptions"
                     :series="realise_mensuel_intervention_graph.series"></apexchart>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import html2canvas from "html2canvas";
import {jsPDF} from "jspdf";
import dayjs from "dayjs";
import SiteTreeSelector from "@/views/SiteTreeSelector";

let statut_select = {
  "": "Statut inconnu",
  "unknown": "Statut inconnu",
  "waiting": "En attente",
  "unassigned": "Non assigné",
  "assigned": "Assigné",
  "running": "En cours",
  "validation": "A valider",
  "to_note": "A noter",
  "no_cost": "Sans coût",
  "finished": "Réalisée",
}

export default {
  name: 'StatInterventions',
  components: {"apexchart": VueApexCharts, SiteTreeSelector},
  async mounted() {
    if (this.$store.getters["interventions/interventions"].length === 0) {
      await this.$store.dispatch("interventions/fetchInterventions");
    }
    if (this.$store.getters["sites/allSites"].length === 0) {
      await this.$store.dispatch("sites/fetchSites");
    }
    this.loaded = true;
  },
  data() {
    return {loaded: false};
  },
  computed: {
    count_interventions_by_state() {
      return this.$store.getters["interventions/stats/count_interventions_by_state"];
    },
    count_interventions_by_state_graph() {
      return {
        series: [{
          name: "Nombre d'interventions",
          data: Object.values(this.count_interventions_by_state)
        }],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 350
          },
          title: {
            text: "Répartition actuelle des interventions",
            align: "center",
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val;
              }
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: Object.keys(this.count_interventions_by_state).map(state => statut_select[state]),
          },
        }
      }
    },
    realise_mensuel_intervention_graph() {
      return {
        series: [{
          name: 'Dépense ponctuelle',
          data: this.$store.getters["interventions/stats/interventions_depenses_ponctuelles_par_mois"],
        }, {
          name: 'Sous contrat supplémentaire',
          data: this.$store.getters["interventions/stats/interventions_depenses_sous_contrat_supplementaire_par_mois"],
        }, {
          name: 'Casse',
          data: this.$store.getters["interventions/stats/interventions_depenses_casse_par_mois"],
        }],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded'
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"],
          },
          yaxis: {
            title: {
              text: 'Réalisé'
            }
          },
          title: {
            text: "Dépenses réalisées en interventions",
            align: "center",
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + " €";
              }
            }
          }
        },
      }
    },
    selected_year: {
      get() {
        return this.$store.getters["finance/stats/getSelectedYear"];
      },
      set(value) {
        return this.$store.commit("finance/stats/setSelectedYear", value);
      }
    },
    active_years() {
      return ["Pas de date", ...this.$store.getters["finance/stats/active_years"]];
    },
    sites_select() {
      return [
        {value: null, name: "Tous les sites"},
        ...this.$store.getters["sites/allSites"]
            .map(site => ({"name": this.site_name(site), "value": this.site_name(site)}))
      ];
    },
    selected_site_tree: {
      get() {
        return this.$store.getters["interventions/stats/getSelectedSiteTree"];
      },
      set(value) {
        return this.$store.commit("interventions/stats/setSelectedSiteTree", value)
      }
    },

  },
  methods: {
    site_name(site) {
      let siteObject = site;
      if (siteObject === null || siteObject === undefined) return "Non défini";
      let siteText = siteObject.name;
      if (siteObject.parent !== null) {
        siteText += `, ${siteObject.parent}`;
      }
      if (siteObject.top !== null) {
        siteText += `, ${siteObject.top}`;
      }
      return siteText;
    },
    async printStats() {
      let statNode = document.querySelector("#stat-interventions")
      let canvas = await html2canvas(statNode, {
        scale: 2
      });
      var image = new Image();
      image.src = canvas.toDataURL("image/png");
      const exportPdf = new jsPDF({
        orientation: "landscape",
        unit: "px",
        format: [canvas.width * 0.6, canvas.height * 0.6]
      });
      exportPdf.addImage({imageData: image, x: 0, y: 0});
      exportPdf.save(`interventions${dayjs().format("DD-MM-YYYYTHH_mm")}.pdf`);
    }
  }
}
</script>